import React, { useState } from 'react';
import { useRatings } from '../lib/useRatings';

const GOLD  = '#FFB300';
const GREY  = '#E0E0E0';
const STAR  = '★';

function Stars({ score, max = 5, onPick, size = 36 }) {
  const [hover, setHover] = useState(0);
  const active = hover || score || 0;

  return (
    <div style={{ display: 'flex', gap: 2 }}>
      {Array.from({ length: max }).map((_, i) => {
        const val = i + 1;
        return (
          <button
            key={i}
            onClick={() => onPick && onPick(val)}
            onMouseEnter={() => onPick && setHover(val)}
            onMouseLeave={() => onPick && setHover(0)}
            style={{
              fontSize: size,
              color: val <= active ? GOLD : GREY,
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: onPick ? 'pointer' : 'default',
              lineHeight: 1,
              transition: 'color .1s',
            }}
          >
            {STAR}
          </button>
        );
      })}
    </div>
  );
}

export default function StarRating({ activityId }) {
  const { avg, count, myScore, loading, submitRating } = useRatings(activityId);
  const [selected, setSelected] = useState(0);
  const [status, setStatus]     = useState('idle'); // idle | saving | saved | error

  async function handleSave() {
    if (!selected) return;
    setStatus('saving');
    const result = await submitRating(selected);
    setStatus(result.ok ? 'saved' : 'error');
  }

  if (loading) return null;

  const alreadyRated = myScore !== null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>

      {/* Average score */}
      <div style={{ fontSize: 13, fontWeight: 700, color: '#555' }}>
        {count > 0
          ? '⭐ ' + avg + ' (' + count + ' ' + (count === 1 ? 'ocena' : count < 5 ? 'oceny' : 'ocen') + ')'
          : '⭐ Brak ocen — oceń jako pierwszy!'}
      </div>

      {/* Stars */}
      {alreadyRated || status === 'saved' ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <Stars score={myScore || selected} size={20} />
          <div style={{ fontSize: 12, color: '#999' }}>Twoja ocena została już zapisana</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Stars score={selected} onPick={setSelected} size={20} />
          {selected > 0 && status !== 'saved' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <button
                onClick={handleSave}
                disabled={status === 'saving'}
                style={{
                  padding: '8px 16px', borderRadius: 10, border: 'none',
                  background: GOLD, color: '#fff', fontWeight: 700,
                  fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
                  opacity: status === 'saving' ? 0.7 : 1,
                }}
              >
                {status === 'saving' ? 'Zapisywanie...' : 'Zapisz ocenę'}
              </button>
              {status === 'error' && (
                <span style={{ fontSize: 12, color: '#DC2626' }}>
                  Nie udało się zapisać. Spróbuj ponownie.
                </span>
              )}
            </div>
          )}
          {selected === 0 && (
            <div style={{ fontSize: 12, color: '#bbb' }}>Oceń to miejsce</div>
          )}
        </div>
      )}
    </div>
  );
}